// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"c2f19ac5","218":"c6be56a7","679":"088c6361","728":"7a0eb98c"}[chunkId] + ".chunk.css";
};